import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/index/index.vue'),
    meta: {
      title: '欢迎您～'
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/index/home.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('../views/index/service.vue'),
    meta: {
      title: '班管家365服务'
    }
  },
  {
    path: '/service2',
    name: 'Service2',
    component: () => import('../views/index/service2.vue'),
    meta: {
      title: '班管家系统配置'
    }
  },
  {
    path: '/explore',
    name: 'Explore',
    component: () => import('../views/index/explore.vue'),
    meta: {
      title: '百年传承'
    }
  },
  {
    path: '/life',
    name: 'Life',
    component: () => import('../views/index/life.vue'),
    meta: {
      title: '知水擅水'
    }
  },
  {
    path: '/appointment',
    name: 'Appointment',
    component: () => import('../views/index/appointment.vue'),
    meta: {
      title: '展厅预约'
    }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/index/news.vue'),
    meta: {
      title: '新闻资讯'
    }
  },
  {
    path: '/news-detail/:id',
    name: 'News-detail',
    component: () => import('../views/index/news-detail.vue'),
    meta: {
      title: '新闻详情'
    }
  },
  {
    path: '/china-case',
    name: 'China-case',
    component: () => import('../views/index/china-case.vue'),
    meta: {
      title: '中国案例'
    }
  },
  {
    path: '/global-case',
    name: 'Global-case',
    component: () => import('../views/index/global-case.vue'),
    meta: {
      title: '全球案例'
    }
  },
  {
    path: '/case-detail/:id',
    name: 'Case-detail',
    component: () => import('../views/index/case-detail.vue'),
    meta: {
      title: '案例详情'
    }
  },
  {
    path: '/product-supply-system',
    name: 'product-supply-system',
    component: () => import('../views/index/product-supply-system.vue'),
    meta: {
      title: '供水系统'
    }
  },
  {
    
    path: '/product-drainage-system',
    name: 'product-drainage-system',
    component: () => import('../views/index/product-drainage-system.vue'),
    meta: {
      title: '排水系统'
    }
  },
  {
    path: '/product-six-dimensional',
    name: 'product-six-dimensional',
    component: () => import('../views/index/product-six-dimensional.vue'),
    meta: {
      title: '六维全面水管理体系'
    }
  },
  {
    // 建筑管路系统综合解决方案 —— 七个二级系统共用同一个页面组件，
    // 内容由 src/data/building-pipe.js 按 slug 提供
    path: '/product-building/:slug',
    name: 'product-building-system',
    component: () => import('../views/index/product-building-system.vue'),
    meta: {
      title: '建筑管路系统综合解决方案'
    }
  },
  {
    path: '/product-solution',
    name: 'product-solution',
    component: () => import('../views/index/product-solution.vue'),
    meta: {
      title: '全屋活水解决方案'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/index/about.vue'),
    meta: {
      title: '关于班尼戈'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/index/contact.vue'),
    meta: {
      title: '联系我们'
    }
  },
  {
    // 兜底：未匹配到的地址回首页，避免出现空白页
    path: '*',
    redirect: '/home'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // 切换路由回到页面顶部；带 #锚点 时滚到对应位置
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { selector: to.hash, offset: { x: 0, y: 100 } }
    return { x: 0, y: 0 }
  }
})

export default router
